import {toggleMark} from "prosemirror-commands";
import {schema} from "../../config/schema";

export const toggleMarkItalic = toggleMark(schema.marks.italic)
